module.exports = __webpack_public_path__ + "static/crag_cat-ad18ec81ce2f61572b19459da8400a58.png";